import { useCallback } from 'react';
import { ROW_TYPES, COLUMNS } from '../tableConfig';
import { DataListItem, HeaderListItem } from '../types';
import { DATA_TYPES, getDataType } from '@constants';
import { FetchDataOverviewByDataTypeState } from '../DataTypeUpdatesOverview';

export const useMainListBuilder = ({
  dataOverviewByDataTypeHash,
}: {
  dataOverviewByDataTypeHash: FetchDataOverviewByDataTypeState['dataOverviewByDataTypeHash'];
}) => {
  const itemBuilder = useCallback(() => {
    const listItems: (HeaderListItem | DataListItem)[] = [];

    // Headers row
    const headerListItem = {
      id: ROW_TYPES.HEADER,
      rowType: ROW_TYPES.HEADER,
      disableRowHover: true,
      isStickyHeader: true,
      cellClassNameByColumns: {
        [COLUMNS.DATA_TYPE]: ['zindex3'],
      },
    } as HeaderListItem;

    listItems.push(headerListItem);

    // Data rows
    DATA_TYPES.forEach((dataType) => {
      const overviewData = dataOverviewByDataTypeHash?.[dataType];
      const dataTypeObj = getDataType(dataType);

      if (overviewData && dataTypeObj) {
        listItems.push({
          id: dataType,
          rowType: ROW_TYPES.DATA,
          disableRowHover: true,
          dataTypeLabel: dataTypeObj.label,
          cellClassNameByColumns: {
            [COLUMNS.DATA_TYPE]: ['sticky'],
          },
          ...overviewData,
        } as DataListItem);
      }
    });

    const list = {
      listItems,
    };

    return list;
  }, [dataOverviewByDataTypeHash]);
  return itemBuilder;
};
